import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick"; 
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import './Home.css';

function Home() {
  const services = [
    { title: 'Virtual CFO Services', image: '/images/virtual_cfo.jpg', link: '/services/virtual-cfo' },
    { title: 'Bookkeeping & Accounting', image: '/images/bookkeeping_accounting.jpg', link: '/services/bookkeeping' },
    { title: 'Taxation Services', image: '/images/taxation.jpg', link: '/services/taxation' },
    { title: 'Corporate Law & Secretarial', image: '/images/corporate_law.jpg', link: '/services/corporate-law' },
    { title: 'Startup Consulting', image: '/images/startup_consulting.jpg', link: '/services/startup-consulting' },
    { title: 'Business Advisory', image: '/images/business_advisory.jpg', link: '/services/business-advisory' },
    { title: 'International Business', image: '/images/international.jpg', link: '/services/international-business' },
    { title: 'Payroll & HR Services', image: '/images/payroll.jpg', link: '/services/payroll-hr' },
  ];

  const industries = [
    { title: 'IT & Software', image: '/images/it&software1.jpg', link: '/industries/it-software' },
    { title: 'Manufacturing & Engineering', image: '/images/manifacturing&engineering.jpg', link: '/industries/manufacturing-engineering' },
    { title: 'Real Estate & Infrastructure', image: '/images/realestate&infrastructure.jpg', link: '/industries/real-estate' },
    { title: 'Media & Entertainment', image: '/images/media&entertainment.jpg', link: '/industries/media-entertainment' },
    { title: 'Retail & E-commerce', image: '/images/retail&e-commerce.jpg', link: '/industries/retail-ecommerce' },
    { title: 'Banking, Financial Services & Insurance', image: '/images/banking&finance.jpg', link: '/industries/bfsi' },
    { title: 'Tourism & Hospitality', image: '/images/hospitality&tourism.jpg', link: '/industries/tourism-hospitality' },
    { title: 'Aquaculture & Agriculture', image: '/images/agri&aqua.jpg', link: '/industries/agro-aqua' },
    { title: 'Health Care', image: '/images/healthcare1.jpg', link: '/industries/healthcare' },
    { title: 'Education', image: '/images/education1.jpg', link: '/industries/education' },
    { title: 'NGOs and Trusts', image: '/images/ngo.jpg', link: '/industries/ngos-trusts' },
  ];

  const processSteps = [
    { icon: '/images/work2.png', title: 'Share Your Goal', description: 'Every successful journey starts with a clear destination.' },
    { icon: '/images/work1.png', title: 'Find a Challenges', description: 'Understanding begins with finding the real challenges.' },
    { icon: '/images/work3.png', title: 'Get a Solution', description: 'Solutions designed to secure your future success.' },
  ];

  const heroSlides = [
    { image: '/images/hero_illustration_1+.png', heading: 'Excellence In Finance & Technology.', subheading: 'Driven by integrity, powered by technology — redefining the future of finance for everyone.' },
    { image: '/images/hero_illustration_2.png', heading: 'Building A Good Finanical Standing.', subheading: 'Modern solutions for evolving financial landscapes and digital innovations.' },
    { image: '/images/hero_illustration_3.png', heading: 'Smart Finance,Smarter Decisions.', subheading: 'Enabling startups and enterprises with AI-driven financial strategies.' },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Industry Carousel Settings
  const industrySettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  // Client Carousel Settings
  const clientSettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section" style={{ backgroundImage: `url('${heroSlides[currentSlide].image}')` }}>
        <div className="hero-text">
          <h1>{heroSlides[currentSlide].heading}</h1>
          <p>{heroSlides[currentSlide].subheading}</p>
          <Link to="/contact" className="cta-button">Connect with us</Link>
        </div>
        <div className="hero-arrow-right">
          <button onClick={() => setCurrentSlide((currentSlide + 1) % heroSlides.length)}>&#8250;</button>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="card-section">
        <div className="card-wrapper">
          <div className="card-block">
            <img src="/images/target.png" alt="Vision Icon" className="card-icon" />
            <h2 className="card-heading">OUR VISION</h2>
            <h3>Fulfilling clients requirements to have long term relationships.</h3>
            <p>To be the most trusted partner for financial consultancy, driving growth and empowering businesses and individuals to achieve their financial aspirations.</p>
          </div>
          <div className="card-block">
            <img src="/images/focus.png" alt="Mission Icon" className="card-icon" />
            <h2 className="card-heading">OUR MISSION</h2>
            <h3>Committed to our client's financial well-being and success</h3>
            <p>We strive to deliver high-quality, customized financial solutions with integrity, agility, and innovation that help our clients unlock their financial potential and stay ahead in a competitive world.</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <h2 className="section-title">OUR EXPERTISE SERVICES</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <img src={service.image} alt={service.title} />
              <h3>{service.title}</h3>
              <Link to={service.link} className="service-btn">Know More</Link>
            </div>
          ))}
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="services-section industries-section">
        <h2 className="section-title">INDUSTRIES WE SERVE</h2>
        <Slider {...industrySettings}>
          {industries.map((industry, index) => (
            <div className="industry-card" key={index}>
              <img src={industry.image} alt={industry.title} />
              <h3>{industry.title}</h3>
              <Link to={industry.link} className="service-btn">Know More</Link>
            </div>
          ))}
        </Slider>
      </section>

      {/* Milestones Section */}
      <section className="milestones-section">
        <h2 className="milestones-title">Our Milestones</h2>
        <div className="timeline">
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone1.png" alt="2023" /></div>
            <h3>2023</h3>
            <p>FINTEXL was founded in Hyderabad with a mission to empower startups and SMEs with accessible, tech-driven financial advisory services. The foundation was laid with a small team and big ambition.</p>
          </div>
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone2.png" alt="2024" /></div>
            <h3>2024</h3>
            <p>With client trust and word-of-mouth growth, FINTEXL expanded its services across Telangana and Andhra Pradesh, onboarded 100+ active clients, and strengthened its Virtual CFO & compliance offerings.</p>
          </div>
          <div className="timeline-year">
            <div className="icon"><img src="/images/milestone3.png" alt="2025" /></div>
            <h3>2025</h3>
            <p>FINTEXL crossed the 500+ client mark, built long-term partnerships with corporates, and began digital transformation projects to automate compliance and financial reporting processes.</p>
          </div>
        </div>
      </section>

      {/* Working Process Section */}
      <section className="working-process-section">
        <h2 className="working-title">Working Process</h2>
        <p className="working-subtext">FINTEXL Consulting works with businesses to solve challenges and find new ways to grow.We help businesses overcome challenges and unlock new opportunities for success.</p>
        <div className="steps-wrapper">
          {processSteps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-icon">
                <img src={step.icon} alt={step.title} />
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Our Goals Section */}
      <section className="goals-section">
        <div className="goals-header">
          <h2 className="goals-title">Our Goals</h2>
          <p className="goals-subtext">FINTEXL delivers expert financial and tax solutions tailored to businesses of all sizes. Our goal is to simplify complexity and drive long-term growth.</p>
        </div>
        <div className="goals-cards">
          <div className="goal-card dark">
            <img src="/images/goals1.png" alt="Financial Services" />
            <h3>Financial Services</h3>
            <p>Our Company offers a range of financial services to individuals, businesses, and organizations</p>
          </div>
          <div className="goal-card blue">
            <img src="/images/goals2.png" alt="Empowering Clients" />
            <h3>Empowering Clients</h3>
            <p>Our aim is to help clients manage their finances, invest for the future, and achieve their financial goals</p>
          </div>
          <div className="goal-card dark">
            <img src="/images/goals3.png" alt="Building Partnership" />
            <h3>Building Trusted Partnership</h3>
            <p>We also prioritize building strong relationships with our clients, building trust, and delivering values</p>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="clients-section">
        <h2 className="clients-title">Our Clients</h2>
        <div className="client-slider">
          <Slider {...clientSettings}>
            <div className="client-logo"><img src="/images/neemsboro_darkgreen_hd.png" alt="Neemsboro Logo" /></div>
            <div className="client-logo"><img src="/images/bhanodaya-logo.png" alt="Bhanodaya" /></div>
            <div className="client-logo"><img src="/images/Acctzen.png" alt="Acctzen" /></div>
            <div className="client-logo"><img src="/images/sreekaram_acctzen.png" alt="Sreekaram Farms" /></div>
            <div className="client-logo"><img src="/images/immunyfit_blue.svg" alt="Immunyfit Blue" /></div>
            <div className="client-logo"><img src="/images/adore_hd.png" alt="adore" /></div>
            <div className="client-logo"><img src="/images/Matrix Intelligence.png" alt="Matrix Intelligence" /></div>
            <div className="client-logo"><img src="/images/kkaveribus.jpg" alt="kaveri" /></div>
            <div className="client-logo"><img src="/images/minimiracles.png" alt="Mini Miracles" /></div>
            <div className="client-logo"><img src="/images/hrksons_hd.png" alt="Mini Miracles" /></div>
            <div className="client-logo"><img src="/images/shooter_spot.png" alt="Mini Miracles" /></div>
          </Slider>
        </div>
      </section>

      {/* Testimonials Section */}
   {/* Testimonials Section */}
<section className="testimonials-section">
  <div className="testimonials-header">
    <h2 className="testimonials-title">Client Testimonials</h2>
    <p className="testimonials-subtext">
     Hear from our clients how FINTEXL’s expertise has helped transform their businesses. Real stories of success, trust, and growth.
    </p>
  </div>
  <div className="testimonials-slider">
    <Slider
      dots={false}
      infinite={true}
      speed={1000}
      slidesToShow={3}
      slidesToScroll={1}
      autoplay={true}
      autoplaySpeed={3000}
      arrows={true}
      pauseOnHover={true}
      responsive={[
        {
          breakpoint: 1024,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 600,
          settings: { slidesToShow: 1 }
        },
      ]}
    >
      <div className="testimonial-card">
        <div className="testimonial-content">
          <h4>Srinivas Patnayak</h4>
          <span>Hyderabad, India</span>
          <p>FINTEXL transformed the way we manage our finances. Their strategic insights and meticulous planning helped us streamline operations and improve profitability. They’re not just consultants; they’re growth partners we can trust.</p>
        </div>
      </div>
      <div className="testimonial-card">
        <div className="testimonial-content">
          <h4>A Shanthi</h4>
          <span>Houston,USA</span>
          <p>From complex financial forecasting to daily accounting, FINTEXL's team delivered precision and clarity at every step. Their expertise helped us secure better funding and optimize our cash flow like never before.</p>
        </div>
      </div>
      <div className="testimonial-card">
        <div className="testimonial-content">
          <h4>Dan Krishnan</h4>
          <span>Hyderabad, India</span>
          <p>Partnering with FINTEXL gave us the confidence to expand our business. Their financial strategies and risk management solutions were instrumental in driving our growth. Highly professional and reliable.</p>
        </div>
      </div>
       <div className="testimonial-card">
        <div className="testimonial-content">
          <h4>K Rakesh</h4>
          <span>Hyderabad, India</span>
          <p>FINTEXL’s financial advisory services were a game changer for our startup. They helped us design a solid financial roadmap, manage compliance effortlessly, and prepare us for investor pitches with detailed reports.</p>
        </div>
      </div>
       <div className="testimonial-card">
        <div className="testimonial-content">
          <h4>Shivakumar</h4>
          <span>Hyderabad, India</span>
          <p>What impressed us most about FINTEXL is their ability to customize solutions that fit our unique business needs. They combined technology with financial expertise to bring transparency and efficiency to our operations.</p>
        </div>
      </div>
      
    </Slider>
  </div>
</section>

    </div>
  );
}

export default Home;
















